"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toPersianDigits = exports.toEnglishDigits = exports.toCurrencyFormat = void 0;

var toPersianDigits = function toPersianDigits(value) {
  var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  return value.replace(/[0-9]/g, function (x) {
    return id[+x];
  });
};

exports.toPersianDigits = toPersianDigits;

var toEnglishDigits = function toEnglishDigits(value) {
  var id = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];

  for (var i = 0; i < 10; i++) {
    value = value.replace(id[i], i);
  }

  return value;
};

exports.toEnglishDigits = toEnglishDigits;

var toCurrencyFormat = function toCurrencyFormat(n) {
  return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

exports.toCurrencyFormat = toCurrencyFormat;